"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GoodTagTypes = _interopRequireDefault(require("./GoodTagTypes"));

var _default = {
  SORT_BY: 'sortBy',
  LIMIT: 'limit',
  PAGE: 'page',
  PRICE: 'price',
  SUB_TYPE: 'subType',
  CHILD_TYPES: 'childType',
  CODING_TYPE: _GoodTagTypes.default.COS_TEMPLATE_CODING_TYPE,
  MODULE_COMPATIBILITY: _GoodTagTypes.default.MODULE_COMPATIBILITY,
  MODULE_PURPOSE: _GoodTagTypes.default.MODULE_PURPOSE,
  PAGE_LAYOUT: _GoodTagTypes.default.COS_TEMPLATE_LAYOUT,
  INDUSTRY: _GoodTagTypes.default.INDUSTRY,
  TEMPLATE_PURPOSE: _GoodTagTypes.default.COS_TEMPLATE_INTENT,
  FEATURES: _GoodTagTypes.default.COS_TEMPLATE_FEATURES,
  SEARCH_TERM: 'searchTerm',
  PROVIDER: 'provider'
};
exports.default = _default;
module.exports = exports.default;